import { render, staticRenderFns } from "./classicCase2.vue?vue&type=template&id=d420fcda&"
import script from "./classicCase2.vue?vue&type=script&lang=js&"
export * from "./classicCase2.vue?vue&type=script&lang=js&"
import style0 from "./classicCase2.vue?vue&type=style&index=0&id=d420fcda&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports